export class InAppMessageConfig {
  public static EndPoint = {
    User: {
      getassociatedusersForCase: `/solution/in-app-message/message/{entityType}/{entityId}/recipients`
    },
    
    // Message endpoints (for future use)
    Message: {
      sendMessage: '/solution/in-app-message/message/send',

      getInboxMessages: '/solution/in-app-message/messages/inbox',
      getSentMessages: '/solution/in-app-message/messages/inbox',
      getDraftMessages: '/solution/in-app-message/messages/inbox',
      getArchivedMessages: '/solution/in-app-message/messages/inbox',
      markAsRead: '/solution/in-app-message/messages/message/{messageId}/read',
      getUnreadCount: '/solution/in-app-message/unread-count',
      getUnreadCountsAll: '/solution/in-app-message/unread-counts/all'
    }
  };

  /**
   * Replace placeholder in endpoint URL with actual value
   * @param endpoint - The endpoint URL with placeholders
   * @param params - Object containing parameter values
   * @returns Formatted endpoint URL
   */
  public static formatEndpoint(endpoint: string, params: { [key: string]: string | number }): string {
    let formattedEndpoint = endpoint;
    console.log('formated endpoint',formattedEndpoint)
    console.log('params after format',params)
    for (const [key, value] of Object.entries(params)) {
      formattedEndpoint = formattedEndpoint.replace(`{${key}}`, value.toString());
    }
    
    return formattedEndpoint;
  }

  

  /**
   * Get the endpoint for users by application  query 
   * @param entityId - The application ID
   * @param entityType 
   * @returns Formatted endpoint URL
   */
  public static getassociatedusersForCase(entityType: string, entityId: number,): string {
    return this.formatEndpoint(this.EndPoint.User.getassociatedusersForCase, { entityType, entityId });
  }
} 